export {FooterMenu} from './FooterMenu'
export {FooterContacts} from './FooterContacts'
export {FooterSocial} from './FooterSocial'
export {FooterSubscription} from './FooterSubscription'
export {Copyright} from './Copyright'
